module.exports = __webpack_public_path__ + "static/media/cake.245575b8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/cake.JPG
// module id = 560
// module chunks = 0